export const filterArgoRoPumps = (roPayload, project) => {
  const antiscalant = project?.split(' ')[1];
  return Object.keys(roPayload).filter(
    key =>
      key.startsWith('roPump_') &&
      roPayload[key]?.argo_dict?.argo_flag === true &&
      roPayload[key]?.argo_dict?.antiscalant === antiscalant
  );
};

export const getArgoElementModels = (argoRoPumpNames, roDict) => {
  const allModels = [];
  argoRoPumpNames.forEach(roPumpName => {
    const gridData = roDict?.ro?.[roPumpName]?.['grid-data'];
    if (gridData && Array.isArray(gridData)) {
      gridData.forEach(row => { if (row.elementModel) allModels.push(row.elementModel); });
    }
  });
  return [...new Set(allModels)].join(', ');
};
